"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileEnding = exports.contentArrayToPath = exports.contentPathToArray = void 0;
/**
 * Takes a path of a workbench content element (file, notebook, directory, ...) and returns its array representation.
 * It's the opposite function to contentArrayToPath()
 * @param path
 */
function contentPathToArray(path) {
    var cleanedPath = path;
    if (cleanedPath.startsWith('/'))
        cleanedPath = cleanedPath.slice(1);
    if (cleanedPath.endsWith('/'))
        cleanedPath = cleanedPath.slice(0, -1);
    var pathArray = ['root'];
    if (cleanedPath.length > 0) {
        pathArray = pathArray.concat(cleanedPath.split('/'));
    }
    return pathArray;
}
exports.contentPathToArray = contentPathToArray;
/**
 * Takes a array representation of a workbench content element (file, notebook, directory, ...) and returns its string
 * representation. It's the opposite function to contentPathToArray().
 * @param pathArray Always starts with the "root" element. Example: ["root", ...]
 */
function contentArrayToPath(pathArray) {
    return "/".concat(pathArray.slice(1, pathArray.length).join('/'));
}
exports.contentArrayToPath = contentArrayToPath;
/**
 * Derive the file ending from a file name (or file path works too)
 * @param fileName
 */
function getFileEnding(fileName) {
    if (!fileName)
        return '';
    var parts = fileName.split('.');
    if (parts.length === 0)
        return '';
    else
        return parts[parts.length - 1];
}
exports.getFileEnding = getFileEnding;
//# sourceMappingURL=content.js.map